import { PartialType, PickType } from '@nestjs/swagger';
import { SubdivisionBuilderSupervisorDto } from './subdivision-builder-supervisor.dto';
import { SubdivisionBuilderSupervisorUpdatableInterface } from '../interfaces/subdivision-builder-supervisor-updatable.interface';

export class SubdivisionBuilderSupervisorUpdateDto
  extends PartialType(
    PickType(SubdivisionBuilderSupervisorDto, ['userId', 'subdivisionId']),
  )
  implements SubdivisionBuilderSupervisorUpdatableInterface {}
